<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasSecondaryAction]="true"
  [secondaryActionText]="'back' | translate"
  secondaryActionIcon="navigate_before"
  (secondaryAction)="back()"
>
  <div class="wrapper--spacing-horizontal flex--column">
    <h1 class="text--h1 text--label spacing--margin-top spacing--margin-bottom">
      {{ 'form.offer.title' | translate }}
    </h1>
    <div class="spacing--margin-top">
      <agr-form [formGroup]="formGroup" class="spacing--margin-top" (submitValue)="submit($event)">
        <div class="flex--row">
          <div class="spacing--margin-right">
            <mat-label class="text--bold" style="display: block"
              >{{ 'form.shared.manureCategoryLabel' | translate }} *</mat-label
            >
            <mat-form-field>
              <mat-select
                formControlName="manureCategory"
                placeholder="{{ 'form.select.placeholder' | translate }}"
                data-test="select-manureCategory"
              >
                @for (manureCategory of manureCategories; track manureCategory) {
                  <mat-option [value]="manureCategory" data-test="manureCategory-item">
                    {{ 'manureCategories.' + manureCategory | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          @if (selectedManureCategory$ | async) {
            <div>
              <mat-label class="text--bold" style="display: block"
                >{{ 'form.shared.manureTypeLabel' | translate }} *</mat-label
              >
              <mat-form-field>
                <mat-select
                  formControlName="manureType"
                  placeholder="{{ 'form.select.placeholder' | translate }}"
                  data-test="select-manureType"
                >
                  @for (manureType of manureTypes$ | async; track manureType) {
                    <mat-option [value]="manureType" data-test="manureType-item">
                      {{ 'manureTypes.' + manureType | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="spacing--margin-top spacing--margin-bottom">
          <mat-label class="text--bold" style="display: block"
            >{{ 'form.shared.amountInTonsLabel' | translate }} *</mat-label
          >
          <div class="flex--row">
            <mat-form-field class="spacing--margin-right">
              <input
                (keypress)="numericOnly($event)"
                matInput
                type="number"
                min="35"
                step="1"
                formControlName="amountInTons"
                placeholder="..."
              />
              <span matSuffix class="form-field-suffix--text">ton</span>
            </mat-form-field>
            <div>
              <div class="notification notification-info text--input-small ng-star-inserted">
                <mat-icon
                  role="img"
                  class="mat-icon notranslate flex--align-self-center material-icons material-icons-outlined mat-ligature-font mat-icon-no-color"
                  aria-hidden="true"
                  data-mat-icon-type="font"
                  >info</mat-icon
                >
                <div class="notification-text">
                  {{ 'form.shared.amountInTonsInfo' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="spacing--margin-top spacing--margin-bottom">
          <mat-label class="text--bold">{{ 'form.offer.priceLabel' | translate }} *</mat-label>
          <mat-radio-group formControlName="paymentType">
            <mat-radio-button color="primary" value="pay">{{
              'form.offer.payLabel' | translate
            }}</mat-radio-button>
            <mat-radio-button color="primary" value="receive">{{
              'form.offer.receiveLabel' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex--row">
          <div class="spacing--margin-right">
            <mat-label class="text--bold" style="display: block"
              >{{ 'form.offer.pricePerTonLabel' | translate }} *</mat-label
            >
            <mat-form-field class="flex__child--auto">
              <input
                (keypress)="numericOnly($event)"
                matInput
                type="number"
                min="0"
                step="1"
                formControlName="pricePerTon"
                placeholder="..."
              />
              <span matSuffix class="form-field-suffix--text">euro</span>
            </mat-form-field>
          </div>
          <div>
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.totalPriceLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto" appearance="outline">
              <input
                matInput
                disabled
                type="number"
                min="0"
                step="1"
                placeholder="..."
                [value]="totalPrice$ | async"
              />
              <span matSuffix class="form-field-suffix--text">euro</span>
            </mat-form-field>
          </div>
        </div>

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        @if (selectedLocation$ | async; as selectedLocation) {
          <div class="spacing--margin-top spacing--margin-bottom">
            <mat-label class="text--bold">{{ 'form.shared.locationLabel' | translate }}</mat-label>
            <div class="location-info spacing--margin-top">
              <strong>{{ selectedLocation.name }}</strong
              ><br />
              {{ selectedLocation.street }} {{ selectedLocation.houseNumber }}<br />
              {{ selectedLocation.postalCode }} {{ selectedLocation.city }}<br />
              <span class="edit-location-link" (click)="openLocationsDialog()">Wijzig</span>
            </div>
          </div>
        }

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="flex--column spacing--margin-top">
          <mat-label class="text--bold" style="display: block">{{
            'form.shared.deliveryPeriodLabel' | translate
          }}</mat-label>
          <div class="flex--row">
            <mat-form-field class="spacing--margin-right">
              <mat-select
                formControlName="desiredDeliveryPeriodFrom"
                placeholder="{{ 'form.select.from' | translate }}"
                data-test="select-deliveryFrom"
              >
                @for (month of months; track month) {
                  <mat-option [value]="month" data-test="month-item">
                    {{ 'months.' + month | translate | titlecase }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-select
                formControlName="desiredDeliveryPeriodTo"
                placeholder="{{ 'form.select.to' | translate }}"
                data-test="select-deliveryTo"
              >
                @for (month of months; track month) {
                  <mat-option [value]="month" data-test="month-item">
                    {{ 'months.' + month | translate | titlecase }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        @if (showTransportType$ | async) {
          <mat-divider
            role="separator"
            class="mat-divider mat-divider-horizontal"
            aria-orientation="horizontal"
          ></mat-divider>
        }

        @if (showTransportType$ | async) {
          <div class="flex--row spacing--margin-top">
            <div class="spacing--margin-right">
              <mat-label class="text--bold" style="display: block">{{
                'form.shared.transportTypeLabel' | translate
              }}</mat-label>
              <mat-form-field>
                <mat-select
                  formControlName="transportType"
                  placeholder="{{ 'form.select.placeholder' | translate }}"
                  data-test="select-transportType"
                >
                  @for (transportType of transportTypes; track transportType) {
                    <mat-option [value]="transportType" data-test="transportType-item">
                      {{ 'transportTypes.' + transportType | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="flex--row spacing--margin-top">
          <div class="spacing--margin-right">
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.nitrogenContentLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto">
              <input matInput type="text" formControlName="nKgPerTon" placeholder="..." />
              <span matSuffix class="form-field-suffix--text">kg/ton</span>
            </mat-form-field>
          </div>
          <div>
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.totalNitrogenLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto">
              <input
                matInput
                disabled
                type="text"
                [value]="totalN$ | async | number"
                placeholder="..."
              />
              <span matSuffix class="form-field-suffix--text">kg</span>
            </mat-form-field>
          </div>
        </div>

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="flex--row spacing--margin-top">
          <div class="spacing--margin-right">
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.phosphateContentLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto">
              <input matInput type="text" formControlName="pKgPerTon" placeholder="..." />
              <span matSuffix class="form-field-suffix--text">kg/ton</span>
            </mat-form-field>
          </div>
          <div>
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.totalPhosphateLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto">
              <input
                matInput
                disabled
                type="text"
                [value]="totalP$ | async | number"
                placeholder="..."
              />
              <span matSuffix class="form-field-suffix--text">kg</span>
            </mat-form-field>
          </div>
        </div>

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="flex--row spacing--margin-top">
          <div class="spacing--margin-right">
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.potassiumContentLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto">
              <input matInput type="text" formControlName="kKgPerTon" placeholder="..." />
              <span matSuffix class="form-field-suffix--text">kg/ton</span>
            </mat-form-field>
          </div>
          <div>
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.totalPotassiumLabel' | translate
            }}</mat-label>
            <mat-form-field class="flex__child--auto">
              <input
                matInput
                disabled
                type="text"
                [value]="totalK$ | async | number"
                placeholder="..."
              />
              <span matSuffix class="form-field-suffix--text">kg</span>
            </mat-form-field>
          </div>
        </div>

        @if (intermediaries().length) {
          <mat-divider
            role="separator"
            class="mat-divider mat-divider-horizontal"
            aria-orientation="horizontal"
          ></mat-divider>
        }

        <div class="spacing--margin-top spacing--margin-bottom">
          <div class="homogentity-title-group">
            <mat-label class="text--bold">{{
              'form.shared.homogeneousLabel' | translate
            }}</mat-label>
            <div class="spacing--margin-left intermediary-info-button">
              <mat-icon
                matTooltip="{{ 'form.shared.homogenity-info' | translate }}"
                class="intermediary-info-button"
                >info_outline</mat-icon
              >
            </div>
          </div>
          <mat-radio-group formControlName="isHomogeneous">
            <mat-radio-button color="primary" [value]="true">{{
              'homogeneity.homogeneous' | translate
            }}</mat-radio-button>
            <mat-radio-button color="primary" [value]="false">{{
              'homogeneity.notHomogenous' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <mat-divider
          role="separator"
          class="mat-divider mat-divider-horizontal"
          aria-orientation="horizontal"
        ></mat-divider>

        <div class="spacing--margin-top">
          <button
            [disabled]="formGroup.invalid"
            type="submit"
            class="spacing--margin-top"
            mat-flat-button
            color="accent"
            data-test="primary-action-button"
          >
            <mat-icon>add</mat-icon> {{ 'form.offer.submitLabel' | translate }}
          </button>
        </div>
      </agr-form>
    </div>
  </div>
  <mat-list role="list" class="container"> </mat-list>
</agr-page-toolbar>
